import { brl } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { discountCalc } from "./discount";

// Bloco de fechamento: Subtotal / Desconto (% ou R$) / Total final.
export function DiscountBox({ subtotal, type, value, onType, onValue, testid = "discount" }) {
  const calc = discountCalc(subtotal, type, value);
  const label =
    type === "PERCENTUAL" && calc.amount > 0
      ? `${Number(value)}% (- ${brl(calc.amount)})`
      : `- ${brl(calc.amount)}`;

  return (
    <div
      className="space-y-3 rounded-xl border border-white/10 bg-secondary/40 p-4"
      data-testid={`${testid}-box`}
    >
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Subtotal</span>
        <span className="font-num" data-testid={`${testid}-subtotal`}>
          {brl(calc.subtotal)}
        </span>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Desconto
        </span>
        <div className="flex items-center gap-2">
          <div className="flex overflow-hidden rounded-full border border-white/15">
            {[
              ["PERCENTUAL", "%"],
              ["VALOR", "R$"],
            ].map(([k, l]) => (
              <button
                key={k}
                type="button"
                onClick={() => onType(k)}
                data-testid={`${testid}-type-${k.toLowerCase()}`}
                className={`px-3 py-1.5 text-xs font-semibold transition-colors ${
                  type === k ? "bg-brand text-background" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <Input
            type="number"
            min="0"
            step="0.01"
            value={value}
            onChange={(e) => onValue(e.target.value)}
            placeholder="0"
            className="h-9 w-24 font-num"
            data-testid={`${testid}-value`}
          />
        </div>
      </div>

      {calc.amount > 0 && (
        <div className="flex items-center justify-between text-sm text-amber-300">
          <span>Desconto concedido</span>
          <span className="font-num" data-testid={`${testid}-amount`}>
            {label}
          </span>
        </div>
      )}
      {calc.error && (
        <p className="text-xs text-red-300" data-testid={`${testid}-error`}>
          {calc.error}
        </p>
      )}

      <div className="flex items-center justify-between border-t border-white/10 pt-3">
        <span className="text-sm text-muted-foreground">Total final</span>
        <span className="font-num text-lg text-brand" data-testid={`${testid}-total`}>
          {brl(calc.total)}
        </span>
      </div>
    </div>
  );
}
